// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { newsListViewStyles } from "@guestsupply/App/Widgets/Blogs/Blogs";
import CaretRight from "@guestsupply/XDL/Icons/CaretRight";
import { color, createLinkIconStyles, ellipsis, xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

newsListViewStyles.blogGridContainer = {
    css: css`
        margin: 32px 0;
    `,
};

newsListViewStyles.blogSectionGridItem = {
    width: [12, 12, 12, 8, 8],
    css: css`
        flex-wrap: wrap;
        ${xScreen("lte", "md")} {
            &&& {
                margin-bottom: 32px;
            }
        }
    `,
};

newsListViewStyles.contentSectionGridItem = {
    width: [12, 12, 12, 4, 4],
};

newsListViewStyles.contentSectionWrapper = {
    css: css`
        width: 100%;
        height: 100%;
        padding: 24px;
        border-radius: 4px;
        ${xScreen("lte", "md")} {
            min-height: 800px;
        }
        ${xScreen("lte", "sm")} {
            min-height: 350px;
        }
    `,
};

newsListViewStyles.titleSummaryWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    `,
};

newsListViewStyles.titleText = {
    variant: "h5",
    as: "p",
    css: css`
        ${ellipsis(2)}
        margin-bottom: 0;
        height: 44px;
        color: ${color("common.ui5")};
        font-weight: bold;
    `,
};

newsListViewStyles.summaryText = {
    size: 14,
    css: css`
        ${ellipsis(3)}
        margin-top: 12px;
        p {
            font-size: 14px;
        }
    `,
};

newsListViewStyles.newsWrapper = {
    css: css`
        border: 1px solid ${color("common.border")};
        border-radius: 4px;
        padding: 17px;
        width: 100%;
        min-height: 205px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        ${xScreen("lte", "md")} {
            max-width: 100%;
        }
    `,
};

newsListViewStyles.readMoreLink = {
    ...createLinkIconStyles(CaretRight, {
        icon: {
            iconProps: {
                size: 12,
                color: "text.link",
                css: css`
                    margin-left: 8px;
                `,
            },
        },
        css: css`
            align-self: flex-start;
        `,
    }),
};
newsListViewStyles.blogWrapper = {
    width: [12, 12, 12, 6, 6],
    css: css`
        ${xScreen("lte", 700)} {
            width: 100%;
            max-width: 100%;
            flex-basis: 100%;
        }
    `,
};
